<div class="task u-mb20 u-mt20">
  <div class="task__table">
    <div class="task__tr">
      <div class="task__td align-middle align-middle--model containerCellDetail">
        <div class="task__number align-number">
          {{index + 1}}
        </div>
        <div class="task__label">
          <div *ngIf="state" [ngClass]="getStatusColor(state)">
            {{state}}
          </div>
        </div>
        <div class="task__label">
          {{equipmentName}}
        </div>
        <div class="task__text">
          {{[equipmentBrand, equipmentModel].join(' - ')}}
        </div>
        <div *ngIf="note" class="task__text" style="
            background: #f2f0e9;
            color: black;
        ">
          {{note}}
        </div>
      </div>
      <div class="task__td align-middle containerCellDetail">
        <div class="task__label task__label--icon task__label--zone">
          Zonas registradas:
        </div>
        <div class="task__text">
          <ul>
            <li *ngFor="let item of conductionZones">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td align-middle containerCellDetail">
        <div class="task__label task__label--icon task__label--type">
          Tipo de licencia
        </div>
        <div class="task__text">
          {{
            licenseTypes.join(' y ')
          }}
        </div>
      </div>
      <div class="task__td align-middle containerCellDetail" *ngIf="municipalLicenses.length > 0">
        <div class="task__label task__label--icon task__label--license">
          Lic. municipal requerida
        </div>
        <div class="task__text">
          <ul>
            <li *ngFor="let item of municipalLicenses">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
      <div class="task__td align-middle containerCellDetail">
        <div class="task__label task__label--icon task__label--end">
          Vencimiento<app-tooltip text="Fecha de caducidad mas cercana de los documentos."></app-tooltip>
        </div>
        <div class="task__text">
          {{expiredAt | date: 'dd/MM/yyyy'}}
        </div>
      </div>
    </div>
  </div>
</div>
